import { number } from "yup";

export const numberOfVehicles = () =>
  number()
    .nullable()
    .transform((value) => {
      if (value === "" || value === null || value === undefined) return null;
      return Number(value);
    })
    .typeError("Number of vehicles is incorrect")
    .integer("Please type in a whole number")
    .min(0, "Number of vehicles is incorrect")
    .max(100, "Number of vehicles is incorrect")
    .optional();
